/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

import { PAGE_SIZES } from '../quarantine.types';
import { buildContainerParams } from './containerQuarantine.api';
import { type ContainerQuery, type ContainerSortField, DEFAULT_CONTAINER_QUERY } from './containerQuarantine.types';

/*
 * The Containers tab's sort and page, carried to the container detail and back in its `back` parameter, so the
 * breadcrumb returns to the same page of the list.
 */

const SORT_FIELDS: ContainerSortField[] = ['QUARANTINE_TIME', 'SEVERITY', 'REPOSITORY', 'POLICY'];

export function serializeContainerQuery(query: ContainerQuery): string {
  return buildContainerParams(query).toString();
}

/** Every value that is missing or not accepted falls back to its default; the URL can be edited by hand. */
export function parseContainerQuery(value: string | null | undefined): ContainerQuery {
  const params = new URLSearchParams(value ?? '');
  const sortBy = params.get('sortBy') as ContainerSortField | null;
  const asc = params.get('asc');
  const page = Number(params.get('page'));
  const pageSize = Number(params.get('pageSize'));
  return {
    sortBy: sortBy && SORT_FIELDS.includes(sortBy) ? sortBy : DEFAULT_CONTAINER_QUERY.sortBy,
    asc: asc === 'true' ? true : asc === 'false' ? false : DEFAULT_CONTAINER_QUERY.asc,
    page: Number.isInteger(page) && page >= 1 ? page : DEFAULT_CONTAINER_QUERY.page,
    pageSize: (PAGE_SIZES as readonly number[]).includes(pageSize) ? pageSize : DEFAULT_CONTAINER_QUERY.pageSize,
  };
}
